import React from "react";
import Navbar from "../navbar/navbar";
import Carousel from "react-bootstrap/Carousel";
import "./header.css";

export default function Header() {
  return (
    <div id="Header" className="header">
      <Navbar></Navbar>
      <Carousel>
        <Carousel.Item interval={3000}>
          <img
            className="d-block w-100 carouselImage"
            src="./images/sub/bg1.avif"
            alt="First slide"
          />
          <div className="box-shadow"></div>
        </Carousel.Item>
        <Carousel.Item interval={3000}>
          <img
            className="d-block w-100 h-70 carouselImage"
            src="./images/sub/bg2.jpeg"
            alt="Second slide"
          />
          <div className="box-shadow"></div>
        </Carousel.Item>
        <Carousel.Item interval={3000}>
          <img
            className="d-block w-100 carouselImage"
            src="./images/sub/gallery3.jpeg"
            alt="Sixth slide"
          />
          <div className="box-shadow"></div>
        </Carousel.Item>
         <Carousel.Item interval={3000}>
          <img
            className="d-block w-100 carouselImage"
            src="./images/sub/bg7.jpeg"
            alt="Sixth slide"
          />
          <div className="box-shadow"></div>
        </Carousel.Item>
        
      </Carousel>
      
    </div>
  );
}
